import { render, staticRenderFns } from "./ArrowBackIcon.vue?vue&type=template&id=235f3dc2&"
import script from "./ArrowBackIcon.vue?vue&type=script&lang=js&"
export * from "./ArrowBackIcon.vue?vue&type=script&lang=js&"
import style0 from "./ArrowBackIcon.vue?vue&type=style&index=0&id=235f3dc2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports